import React, { useEffect, useRef, useState } from "react";
import { useRecoilState } from "recoil";
import { loadingProgressState } from "../store";
import { motion, useScroll, useTransform } from 'framer-motion';


const Loading = () => {
  const stickyRef = useRef(null);
  const [progress, setProgress] = useRecoilState(loadingProgressState);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(()=>{
    const timer = setInterval(()=>{
      setProgress((oldProgress)=>{
        return Math.min(oldProgress + 5, 100);
      })
    }, 100)

    return () => {
      clearInterval(timer);
    }
  }, [setProgress]);

  useEffect(() => {
    const observer = new IntersectionObserver(
        ([entry]) => {
            setIsVisible(entry.isIntersecting);
        },
        { threshold: 0.5 }
    );
    
    if (stickyRef.current) observer.observe(stickyRef.current);
    return () => stickyRef.current && observer.unobserve(stickyRef.current);

   
}, []);
//  <svg className="max-lg:hidden w-full h-auto" width="1327" height="555" viewBox="0 0 657.5 294.49" fill="#091423" xmlns="http://www.w3.org/2000/svg">
//                                  <g>
                                    
//                                <path d="M176.88,0v228.86c0,36.6-31.27,65.63-72.36,65.63H75.93C33.5,294.49,0,265.46,0,228.86v-48.38l62.53-13.46v61.84
//                                     c0,16.41,3.57,19.35,21.44,19.35h10.72c16.53,0,19.65-2.94,19.65-19.35V0H176.88z"/>
//                                 <path d="M361.36,0h67.45l-73.25,201.52v92.97h-62.53v-92.97L219.76,0h67.45l32.16,135.47h9.83L361.36,0z"/>
//                                 <path d="M594.97,0h62.53v294.49h-62.53V177.54h-56.28v116.96h-62.53V0h62.53v131.26h56.28V0z"/> 
                                
//                                 </g>
//                                </svg> 
  return (
    <div className="h-[50vh] w-full mt-40 " ref={stickyRef}>
      {/* 프로그레스 바 */}
      <div className="relative max-[768px]:bottom-12 flex justify-center flex-nowrap pl-[1.38vw] pr-[1.38vw]">
        <div className="pr-[1.38vw] flex flex-nowrap items-end">
            <motion.svg
                
                initial={{ opacity: 0, y: -50 }}
                animate={isVisible ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4 }} 
                className="max-lg:w-[33.194444444444445vw] mr-[1.18px] lg:mr-[0.625vw] w-[53.98px] lg:w-[43.194444444444445vw] h-auto" width="500" height="225" viewBox="0 0 2000 900" fill="#091423" xmlns="http://www.w3.org/2000/svg">
                {/* <path fill-rule="evenodd" clip-rule="evenodd" d="M2.40752e-05 162.436C-0.0328505 205.586 33.6058 229.776 76.3243 229.808C117.748 229.84 140.633 209.577 148.419 185.419L148.389 224.685L189.381 224.717L189.5 68.5129C189.534 24.5002 157.19 0.31159 101.526 0.26909C44.9997 0.22609 12.1833 29.5431 6.54387 68.8049L49.6939 68.8379C52.302 43.8132 71.2975 31.3142 101.071 31.3369C130.413 31.3592 145.938 43.453 145.926 59.4189C145.913 75.7799 126.918 80.8729 97.8184 88.6739C94.6858 89.5139 91.4361 90.3859 88.0803 91.3059C34.1319 105.504 0.0338849 117.992 2.40752e-05 162.436ZM147.598 129.755C147.57 166.432 125.97 198.778 88.43 198.75C63.403 198.73 44.8586 185.34 44.877 161.176C44.8971 134.854 67.3427 124.947 101.438 115.48C126.903 108.164 142.442 101.272 147.629 88.7619L147.598 129.755Z" fill="#091423"></path> */}
              <path class="st0" d="M580.06,21.25V687.5c0,106.55-84.46,191.06-195.47,191.06h-77.22c-114.63,0-205.12-84.51-205.12-191.06V546.65
            l168.92-39.19V687.5c0,47.76,9.65,56.34,57.92,56.34h28.96c44.64,0,53.09-8.57,53.09-56.34V21.25H580.06z"/>
          <path class="st0" d="M1108.86,28.25h182.2l-197.88,586.64v270.66H924.25V614.89L726.37,28.25h182.2l86.88,394.36h26.55
            L1108.86,28.25z"/>
          <path class="st0" d="M1758.76,28.25h168.92v857.31h-168.92V545.08h-152.03v340.47h-168.92V28.25h168.92v382.11h152.03V28.25z"/>
          <path class="st0" d="M154.16,263c-21.2,0-40.12-4.36-56.77-13.07c-16.64-8.71-29.74-21.05-39.3-37.01
            c-9.56-15.96-14.34-34.86-14.34-56.7c0-15.84,2.72-31.29,8.16-46.35c5.44-15.05,12.94-29.12,22.49-42.19
            c9.56-13.07,20.68-24.56,33.37-34.46c12.69-9.9,26.34-17.66,40.95-23.26c14.61-5.6,29.6-8.4,44.99-8.4
            c21.31,0,40.26,4.36,56.85,13.07c16.59,8.72,29.66,21.05,39.22,37.01c9.56,15.96,14.34,34.86,14.34,56.7
            c0,15.85-2.72,31.3-8.16,46.35c-5.44,15.05-12.94,29.12-22.49,42.19c-9.56,13.07-20.68,24.56-33.37,34.46
            c-12.69,9.91-26.34,17.66-40.95,23.26C184.53,260.2,169.54,263,154.16,263z M154.16,256.38c14.61,0,28.92-2.69,42.93-8.06
            c14.01-5.37,27.08-12.79,39.22-22.24c12.14-9.45,22.79-20.46,31.97-33.02c9.17-12.56,16.37-26.06,21.59-40.49
            c5.22-14.43,7.83-29.17,7.83-44.22c0-20.48-4.48-38.2-13.43-53.14C275.3,40.26,263,28.69,247.34,20.49
            c-15.65-8.2-33.53-12.31-53.64-12.31c-14.61,0-28.92,2.69-42.93,8.06c-14.01,5.38-27.08,12.79-39.22,22.24
            C99.43,47.93,88.77,58.94,79.6,71.5c-9.17,12.56-16.37,26.03-21.59,40.41c-5.22,14.37-7.83,29.14-7.83,44.31
            c0,20.6,4.48,38.4,13.43,53.39c8.95,15,21.26,26.54,36.91,34.63C116.18,252.33,134.06,256.38,154.16,256.38z M156.14,210.71
            c-17.36,0-31.31-4.84-41.85-14.52c-10.55-9.68-15.82-22.83-15.82-39.47c0-13.92,2.31-27.08,6.92-39.47
            c4.61-12.39,11.01-23.34,19.2-32.85c8.18-9.51,17.63-16.98,28.34-22.41c10.71-5.43,22.22-8.15,34.52-8.15
            c13.07,0,23.42,4.41,31.06,13.24c7.63,8.83,11.95,20.54,12.94,35.14h-2.14c-1.54-10.64-4.2-19.07-7.99-25.3
            c-3.79-6.22-8.13-10.7-13.02-13.41c-4.89-2.72-9.75-4.07-14.58-4.07c-7.58,0-14.42,2.58-20.52,7.72
            c-6.1,5.15-11.45,11.94-16.07,20.37c-4.61,8.43-8.49,17.66-11.62,27.67c-3.13,10.02-5.47,19.98-7,29.88
            c-1.54,9.9-2.31,18.82-2.31,26.74c0,6.45,0.63,12.22,1.89,17.32c1.26,5.09,3.65,9.08,7.17,11.97c3.51,2.89,8.68,4.33,15.49,4.33
            c7.36,0,14.42-1.95,21.17-5.86c6.76-3.9,13.1-9.11,19.03-15.62c5.93-6.51,11.48-13.72,16.64-21.65h2.31
            c-4.61,8.38-10.05,16.24-16.31,23.6c-6.26,7.36-13.38,13.33-21.34,17.91C174.29,208.42,165.59,210.71,156.14,210.71z M207.22,208.67
            l-14.5-13.92c3.07-2.49,6.18-5.37,9.31-8.66c3.13-3.28,6.18-7.07,9.15-11.37l6.43-12.39h3.79l-10.88,46.35H207.22z M229.3,102.23
            l-1.15-12.22c-1.1-4.07-2.39-7.64-3.87-10.7c-1.48-3.06-3.32-6-5.52-8.83l21.26-14.6h3.3l-10.22,46.35H229.3z"/>
            </motion.svg>
            
        </div>
        <div className="mt-96 w-[50%] h-1 bg-gray-200">
            <div className="h-full bg-black transition-all duration-200 ease-out" style={{ width: `${progress}%` }}></div>
        </div>
      </div>

      
    </div>
  );
};

export default Loading;
